import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { saveSearch } from "./saveSearch";
import { searchKeys } from "../../../utils/propertyData";

export const sortQuery = (q) => {
  let newQArray = q
    ?.replaceAll("undefined:undefined", "")
    ?.split(" AND ");

  let orArray = [];
  let andArray = [];
  // let associationCondition = "";

  newQArray?.forEach((it) => {
    const key = it?.split(":")?.[0]?.replace(/[()]/g, "");

    // pull AssociationYN out separately
    // if (key === "AssociationYN") {
    //   associationCondition = it;
    //   return;
    // }
    
    if (
      searchKeys?.includes(key)
    ) {
      if (it?.startsWith("(") && it?.endsWith(")")) {
        orArray.push(it?.slice(1, -1));
      } else {
        orArray.push(it);
      }
    } else {
      andArray.push(it);
    }
  });

  
  let baseQuery = "";
  if (orArray?.length || andArray?.length) {
    baseQuery = `${andArray?.join(" AND ")}${
      orArray?.length ? ` AND (${orArray?.join(" OR ")})` : ""
    }`;
  }

  // append AssociationYN at very end with OR
  // if (associationCondition) {
  //   baseQuery = baseQuery ? `(${baseQuery}) OR ${associationCondition}` : associationCondition;
  // }

  return baseQuery;
};


export const getPropertyList = createAsyncThunk(
  "LeadSavedSearches/getPropertyList",
  async (data, thunkAPI) => {
    try {
      let searchParams = {
        ...thunkAPI.getState()?.leads?.savedSearches.searchParams,
      };

      let site_id =
        thunkAPI.getState()?.leads?.savedSearches.searchList.data?.site_id?._id;
      let token =
        thunkAPI.getState()?.leads?.savedSearches.searchList.data?.token;

      let query = "";
      let query1 = "";
      let newObj = {};
      let associationCondition = "";

      Object.keys(searchParams).forEach((k) => {
        if (
          (!searchParams[k] &&
            searchParams[k] !== false &&
            searchParams[k] !== 0) ||
          k === undefined ||
          k === null ||
          k === ""
        ) {
          delete searchParams[k];
        } else {
          // handle AssociationYN separately
          if (k === "AssociationYN" && searchParams[k] === true) {
            associationCondition = `${k}:${searchParams[k]}`;
            return; // skip normal handling
          }

          if (
            query &&
            k &&
            k !== "sort" &&
            k !== "start" &&
            k !== "rows" &&
            (searchParams[k] || searchParams[k] === false)
          ) {
            query = query + ` AND ${k}:${searchParams[k]}`;
          } else if (
            k &&
            k !== "sort" &&
            k !== "start" &&
            k !== "rows" &&
            (searchParams[k] || searchParams[k] === false)
          ) {
            query = `q=${k}:${searchParams[k]}`;
          }

          if (
            (k === "sort" || k === "start" || k === "rows") &&
            searchParams[k]
          ) {
            newObj[k] = searchParams[k];
            query1 = query1 + `&${k}=${searchParams[k]}`;
          }
        }
      });

      // append AssociationYN at end OUTSIDE the AND group
      // if (associationCondition) {
      //   if (query) {
      //     query = `${query} OR ${associationCondition}`;
      //   } else {
      //     query = `q=${associationCondition}`;
      //   }
      // }

      let url = `${
        process.env.REACT_APP_IDX_BASE_URL
      }api/v1/properties/${site_id}?${
        data?.isAND ? query : sortQuery(query)
      }${query1}&editSource=iframe${
        data?.isAND ? `&geoOperator=AND` : `&geoOperator=OR`
      }`;
      if (data?.type === "collection") {
        url = `${
          process.env.REACT_APP_IDX_BASE_URL
        }api/v1/properties/${site_id}?q=ListingId:999999&editSource=iframe&type=${
          data?.type || "collection"
        }&name=${data?.name}`;
      }
      const resp = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (resp.data?.meta?.searchId) {
        thunkAPI.dispatch(
          saveSearch({
            title: data?.title,
            searchId: resp.data?.meta?.searchId,
            emailNotification: data?.emailNotification,
            handleSuccess: data?.handleSuccess,
            handleError: data?.handleError,
            geoOperator:
              data?.isAND && data?.type !== "collection" ? "AND" : "OR",
            type: data?.type,
            name: data?.name,
            query: {
              q: query?.replace("q=", ""),
              ...newObj,
            },
          })
        );
      }
      return { ...resp.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
